"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vuex_1 = require("vuex");
var axios_1 = __importDefault(require("axios"));
var jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
var global_1 = require("./global");
/** 領域模型 */
var Model = /** @class */ (function () {
    /**
     * 建構領域模型
     * @param modules 模組
     * @param options 選項
     */
    function Model(name, modules) {
        var _this = this;
        /** 金鑰 */
        this.secure = "CloudFun Co., Ltd.";
        /** 來賓(未授權)用戶 */
        this.guest = CloudFun.guest;
        /**
         * 登入時執行
         */
        this.onLogin = function (data) { return new Promise(function (resolve, reject) {
            if (data && data.account === 'demo' && data.password === 'demo')
                resolve({ status: 200, payload: _this.guest, message: "登入成功" });
            else
                reject({ status: 401, payload: new Error("帳號或密碼錯誤"), message: "帳號或密碼錯誤" }); // eslint-disable-line
        }); };
        /** 登出時執行 */
        this.onLogout = function () { return new Promise(function (resolve, reject) {
            if (_this.user != null)
                resolve({ status: 200, message: "登出成功" });
            else
                reject(new Error("未登入時無法登出"));
        }); };
        /** 重載用戶時執行 */
        this.onReloadUser = function () { return new Promise(function (resolve) {
            resolve({ status: 200, payload: _this.user, message: "已刷新用戶資料" });
        }); };
        /** 重載列舉時執行 */
        this.onReloadEnums = function () { return new Promise(function (resolve) {
            resolve({ status: 200, payload: _this.enums, message: "已刷新列舉資料" });
        }); };
        /** 紀錄日誌時執行 */
        this.onLog = function () { return new Promise(function (resolve) {
            resolve({ status: 200, message: "已紀錄日誌" });
        }); };
        this.name = name;
        var model = this; // eslint-disable-line
        var userJson = null;
        var enumJson = null;
        if (typeof localStorage !== 'undefined' && localStorage !== null) { // client side
            userJson = localStorage.getItem(name + "-user");
            enumJson = localStorage.getItem(name + "-enums");
        }
        if (typeof sessionStorage !== 'undefined' && sessionStorage !== null) { // client side
            if (!userJson)
                userJson = sessionStorage.getItem(name + "-user");
            if (!enumJson)
                enumJson = sessionStorage.getItem(name + "-enums");
        }
        this.store = vuex_1.createStore({
            state: {
                refreshTime: {},
                currentUser: userJson ? JSON.parse(userJson) : model.guest,
                currentEnums: enumJson ? JSON.parse(enumJson) : {},
                currentMenu: [{ title: 'route.home' }],
                currentBreadcrumb: [{ title: 'route.home' }],
                clients: {}
            },
            getters: {
                user: function (state) { return state.currentUser; },
                enums: function (state) { return state.currentEnums; },
                menu: function (state) { return state.currentMenu; },
                breadcrumb: function (state) { return state.currentBreadcrumb; },
            },
            mutations: {
                user: function (state, value) {
                    Object.assign(state.currentUser, value);
                    var key = model.name + "-user";
                    if (typeof localStorage !== 'undefined' && localStorage !== null && localStorage.getItem(key)) { // client side
                        localStorage.setItem(key, JSON.stringify(state.currentUser));
                    }
                    else if (typeof sessionStorage !== 'undefined' && sessionStorage !== null && sessionStorage.getItem(key)) { // client side
                        sessionStorage.setItem(key, JSON.stringify(state.currentUser));
                    }
                },
                enums: function (state, value) {
                    Object.keys(state.currentEnums).forEach(function (key) { return delete state.currentEnums[key]; });
                    Object.keys(value).forEach(function (key) { state.currentEnums[key] = value[key]; });
                    if (typeof localStorage !== 'undefined' && localStorage !== null)
                        localStorage.setItem(model.name + "-enums", JSON.stringify(value));
                },
                menu: function (state, value) {
                    var _a;
                    state.currentMenu.splice(0, state.currentMenu.length);
                    (_a = state.currentMenu).push.apply(_a, value);
                },
                breadcrumb: function (state, value) {
                    var _a;
                    state.currentBreadcrumb.splice(0, state.currentBreadcrumb.length);
                    (_a = state.currentBreadcrumb).push.apply(_a, value);
                },
            },
            actions: {
                login: function (_a, data) {
                    var commit = _a.commit;
                    return new Promise(function (resolve, reject) { return model.onLogin(data).then(function (success) {
                        commit('user', success.payload);
                        CloudFun.item(name + "-user", JSON.stringify(success.payload), !data.rememberMe);
                        CloudFun.send('application.user-changed', success.message || '');
                        resolve(success.payload || model.guest);
                    }, function (failure) {
                        reject(new Error(failure.message));
                    }); });
                },
                logout: function (_a) {
                    var commit = _a.commit;
                    return new Promise(function (resolve, reject) { return model.onLogout().then(function (success) {
                        commit('user', model.guest);
                        CloudFun.item(name + "-user", null);
                        CloudFun.send('application.user-changed', '');
                        resolve(success.payload);
                    }, function (failure) {
                        reject(new Error(failure.message));
                    }); });
                },
                reloadUser: function (_a) {
                    var state = _a.state, commit = _a.commit;
                    return new Promise(function (resolve, reject) {
                        var duetime = new Date();
                        duetime.setSeconds(duetime.getSeconds() - 10);
                        if (!state.refreshTime.currentUser || state.refreshTime.currentUser < duetime) {
                            model.onReloadUser().then(function (success) {
                                state.refreshTime.currentUser = new Date;
                                commit('user', success.payload);
                                resolve(success.payload || model.guest);
                            }, function (failure) {
                                reject(new Error(failure.message));
                            });
                        }
                        else
                            resolve(state.currentUser);
                    });
                },
                reloadEnums: function (_a) {
                    var state = _a.state, commit = _a.commit;
                    return new Promise(function (resolve, reject) {
                        var duetime = new Date();
                        duetime.setSeconds(duetime.getSeconds() - 60);
                        if (!state.refreshTime.enums || state.refreshTime.enums < duetime) {
                            model.onReloadEnums().then(function (success) {
                                state.refreshTime.enums = new Date;
                                commit('enums', success.payload || {});
                                resolve(success.payload || {});
                            }, function (failure) {
                                reject(new Error(failure.message));
                            });
                        }
                        else
                            resolve(state.currentEnums);
                    });
                },
                log: function (context, message) {
                    return new Promise(function (resolve, reject) { return model.onLog(message).then(function (success) { return resolve(success.payload); }, function (failure) {
                        reject(new Error(failure.message));
                    }); });
                }
            },
            modules: modules
        });
        this.dispatch = this.store.dispatch;
        this.commit = this.store.commit;
    }
    // #region Store<ModelState> members 
    Model.prototype.install = function (app, injectKey) { return this.store.install(app, injectKey); };
    Model.prototype.replaceState = function (state) { this.replaceState(state); };
    Model.prototype.subscribe = function (fn, options) { return this.store.subscribe(fn, options); };
    Model.prototype.subscribeAction = function (fn, options) { return this.store.subscribeAction(fn, options); };
    Model.prototype.watch = function (getter, cb, options) { return this.store.watch(getter, cb, options); };
    Model.prototype.registerModule = function (path, module, options) {
        if (Array.isArray(path))
            this.store.registerModule(path, module, options);
        else
            this.store.registerModule(path, module, options);
    };
    Model.prototype.unregisterModule = function (path) {
        if (Array.isArray(path))
            this.store.unregisterModule(path);
        else
            this.store.unregisterModule(path);
    };
    Model.prototype.hasModule = function (path) {
        return Array.isArray(path) ? this.store.hasModule(path) : this.store.hasModule(path);
    };
    Model.prototype.hotUpdate = function (options) {
        this.store.hotUpdate(options);
    };
    Object.defineProperty(Model.prototype, "state", {
        /** 取得目前狀態 */
        get: function () { return this.store.state; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "getters", {
        /** 取得獲取函數，以便取得所需的計算值 */
        get: function () { return this.store.getters; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "clients", {
        /** HTTP Clients */
        get: function () { return this.store.state.clients; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "user", {
        /** 取得目前用戶 */
        get: function () { return this.state.currentUser; },
        /** 設定目前用戶 */
        set: function (value) { this.commit('user', value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "enums", {
        /** 取得列舉 */
        get: function () { return this.state.currentEnums; },
        /** 設定目前用戶 */
        set: function (value) { this.commit('enums', value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "menu", {
        /** 取得目前選單 */
        get: function () { return this.state.currentMenu; },
        /** 設定目前選單 */
        set: function (value) { this.commit('menu', value); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "breadcrumb", {
        /** 取得目前麵包屑 */
        get: function () { return this.state.currentBreadcrumb; },
        /** 設定目前麵包屑 */
        set: function (value) { this.commit('breadcrumb', value); },
        enumerable: false,
        configurable: true
    });
    /**
     * 登入
     * @param data 授權資料
     */
    Model.prototype.login = function (data) {
        return this.dispatch('login', data);
    };
    /** 登出 */
    Model.prototype.logout = function () {
        return this.dispatch('logout');
    };
    /** 重載用戶 */
    Model.prototype.reloadUser = function () {
        return this.dispatch('reloadUser');
    };
    /** 重載列舉 */
    Model.prototype.reloadEnums = function () {
        return this.dispatch('reloadEnums');
    };
    /** 紀錄日誌 */
    Model.prototype.log = function (message) {
        return this.dispatch('log', message);
    };
    /**
     * 取得認證
     * @param type 授權類型
     * @param secure 金鑰
     */
    Model.prototype.getCertificate = function (type, secure) {
        if (!this.user)
            throw new Error("login-first");
        switch (type) {
            case global_1.AuthorizationType.Basic: return btoa(this.user.Id + ":" + this.user.Token);
            case global_1.AuthorizationType.Bearer: return jsonwebtoken_1.default.sign({ id: this.user.Id, Token: this.user.Token }, secure || this.secure);
            default: throw new Error("not-supported");
        }
    };
    Model.createHttpClient = function (baseURL, authType, certificate) {
        var client = axios_1.default.create({ baseURL: baseURL, maxBodyLength: Infinity, maxContentLength: Infinity });
        if (authType)
            client.interceptors.request.use(function (config) {
                try {
                    config.headers.Authorization = global_1.AuthorizationType[authType] + " " + certificate(authType || global_1.AuthorizationType.Basic);
                }
                catch (e) {
                    console.log('Failure to generate certificate: ', e);
                    throw e;
                }
                return config;
            });
        client.interceptors.response.use(function (response) {
            var json = response.data || { status: response.statusText, payload: null, message: response.statusText };
            return json.status >= 200 && json.status < 300
                ? Promise.resolve(json)
                : Promise.reject(json);
        }, function (error) {
            var response = { status: 500, payload: null, message: typeof error === "string" ? error : "System is busy" };
            if (error.response) {
                if (error.response.status)
                    response.status = error.response.status;
                if (error.response.statusText)
                    response.message = error.response.statusText;
                response.payload = error.response;
            }
            return Promise.reject(response);
        });
        return client;
    };
    /**
     * 建立 HTTP 客戶端
     * @param baseURL 基礎網址
     * @param authorized 連線時是否需被授權
     * @param authType 授權類型
     */
    Model.prototype.createHttpClient = function (baseURL, authorized, authType) {
        var _this = this;
        if (authorized === void 0) { authorized = false; }
        if (authType === void 0) { authType = global_1.AuthorizationType.Basic; }
        var client = axios_1.default.create({ baseURL: baseURL, maxBodyLength: Infinity, maxContentLength: Infinity });
        if (authorized)
            client.interceptors.request.use(function (config) {
                try {
                    config.headers.Authorization = global_1.AuthorizationType[authType] + " " + _this.getCertificate(authType || global_1.AuthorizationType.Basic);
                }
                catch (e) {
                    console.log('Failure to generate certificate: ', e);
                    throw e;
                }
                return config;
            });
        client.interceptors.response.use(function (response) {
            var json = response.data || { status: response.statusText, payload: null, message: response.statusText };
            return json.status >= 200 && json.status < 300
                ? Promise.resolve(json)
                : Promise.reject(json);
        }, function (error) {
            var response = { status: 500, payload: null, message: typeof error === "string" ? error : "System is busy" };
            if (error.response) {
                if (error.response.status)
                    response.status = error.response.status;
                if (error.response.statusText)
                    response.message = error.response.statusText;
                response.payload = error.response;
            }
            return Promise.reject(response);
        });
        return client;
    };
    return Model;
}());
exports.default = Model;
